import Strings from './../common/Strings';

export function getPlanInfo(subscription) {
  let planText;
  let canUpgrade;
  const statusInactive = (subscription.status === 'inactive') === '';
  const statusActive = subscription.status === 'active';
  const statusFailedPayment =
    subscription.status === 'incomplete' || subscription.status === 'past_due';
  const willCancel = subscription.cancelAtPeriodEnd;

  if (statusInactive) {
    planText = Strings.BILLING.planBasic;
    canUpgrade = true;
  } else if (statusFailedPayment) {
    planText = Strings.BILLING.planBasic;
    canUpgrade = false;
  } else if (statusActive && !willCancel) {
    planText = Strings.BILLING.premium;
    canUpgrade = false;
  } else if (statusActive && willCancel) {
    planText = Strings.BILLING.planActiveCanceled;
    canUpgrade = true;
  } else {
    planText = Strings.BILLING.planBasic;
    canUpgrade = true;
  }

  return { planText, canUpgrade };
}



// WEBPACK FOOTER //
// ./src/helpers/subscription.js